export default function makeBgImage() {
    const defaultBgOptions = {
        attachment: 'fixed',
        size: 'cover',
        position: 'center',
        repeat: 'no-repeat'
    };

    document.querySelectorAll("img.js-bg-image, .js-bg-image.wp-block-image img").forEach(image => {
        const src = image.getAttribute('src');
        const positionData = image.dataset.bgPosition || defaultBgOptions.position;
        const attachmentData = image.dataset.bgAttachment || defaultBgOptions.attachment;
        const sizeData = image.dataset.bgSize || defaultBgOptions.size;
        const repeatData = image.dataset.bgRepeat || defaultBgOptions.repeat;

        // Ziel-Parent bestimmen
        const figure = image.closest('figure.wp-block-image.js-bg-image');
        const targetParent = figure ? figure.parentNode : image.parentNode;

        targetParent.style.backgroundImage = `url(${src})`;
        targetParent.style.backgroundAttachment = attachmentData;
        targetParent.style.backgroundSize = sizeData;
        targetParent.style.backgroundPosition = positionData;
        targetParent.style.backgroundRepeat = repeatData;

        image.remove();
        if (figure) figure.remove();
    });
}
